class PromotickToken {
    token = "";
    expiration = new Date();
}

export { PromotickToken };
